// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import "@/assets/css/test.css";

import "@/rem/rem.js";

// import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
// Vue.use(ElementUI);

// import axios from "axios";
// Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js